/**
 * Narrow unknown caught values into a user-facing error message.
 */
export function toErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) {
    return err.message;
  }
  if (typeof err === 'object' && err !== null && 'message' in err) {
    const message = (err as { message: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }
  if (typeof err === 'string' && err.trim()) {
    return err;
  }
  return fallback;
}

function errorCode(err: unknown): string | undefined {
  if (typeof err === 'object' && err !== null && 'code' in err) {
    const code = (err as { code: unknown }).code;
    return typeof code === 'string' ? code : undefined;
  }
  return undefined;
}

/** User-facing Spanish copy for Slack compose send failures. */
export function slackSendErrorMessage(err: unknown): string {
  const code = errorCode(err);
  if (code === 'SLACK_MISSING_SCOPE' || /missing_scope/i.test(toErrorMessage(err, ''))) {
    return 'Slack no tiene permiso para enviar (falta chat:write en el token). Actualiza SLACK_USER_TOKEN tras reinstalar la app con ese scope.';
  }
  return toErrorMessage(err, 'No se pudo enviar el mensaje a Slack.');
}

/** Preserve scope/auth hints so the unattended-inbox UI can show remediation. */
export function unattendedInboxErrorMessage(err: unknown): string {
  const code = errorCode(err);
  const message = toErrorMessage(err, 'Error al cargar tus asuntos sin atender.');
  if (code === 'SLACK_MISSING_SCOPE' || /missing_scope/i.test(message)) {
    return `SLACK_MISSING_SCOPE: ${message}`;
  }
  return message;
}
